/**
 * Section — numbered card of the reports one-pager. Shared by the table
 * flow (PatientReportWizard) and the finance flow (FinanceReportFlow).
 * Reveals with the prwSectionIn animation (PatientReportWizard.css).
 */

import { Check } from "@phosphor-icons/react";

function Section({ num, title, done, summary, children, className = "" }) {
  const current = !done;
  return (
    <section className={`prw-section ${current ? "current" : ""} ${className}`}>
      <div className="prw-section-header">
        <span
          className={`prw-section-num ${done ? "done" : ""} ${
            current ? "current" : ""
          }`}
        >
          {done ? <Check size={13} weight="bold" /> : num}
        </span>
        <h3 className="prw-section-title">{title}</h3>
        {summary && <span className="prw-section-summary">{summary}</span>}
      </div>
      <div className="prw-section-body">{children}</div>
    </section>
  );
}

export default Section;
